import React, { useMemo, useState } from 'react';
import { useCart } from '../context/CartContext';

const SupplierStats = () => {
  const { orders } = useCart();
  const [selectedDate, setSelectedDate] = useState('');

  const filteredOrders = useMemo(() => {
    return orders.filter(order => {
      const rawDate = order.date || order.createdAt;
      let dateStr = '';
      try {
        const d = new Date(rawDate);
        if (!isNaN(d)) {
          dateStr = d.toISOString();
        }
      } catch (_) {
        return false;
      }

      const dateMatch = selectedDate ? dateStr.startsWith(selectedDate) : true;
      return dateMatch;
    });
  }, [orders, selectedDate]);

  const generalStats = useMemo(() => {
    const dishCount = {};
    let dailyRevenue = 0;
    let monthlyRevenue = 0;

    const now = new Date();
    const currentMonth = now.getMonth();
    const currentYear = now.getFullYear();

    orders.forEach(order => {
      const orderDate = new Date(order.date || order.createdAt);
      const isSameMonth = orderDate.getFullYear() === currentYear && orderDate.getMonth() === currentMonth;

      (order.items || []).forEach(item => {
        const quantity = item.quantity || 0;
        const cost = item.price || 0;

        // 🟢 Считаем для выбранной даты
        if (selectedDate) {
          const orderDateStr = orderDate.toISOString().split('T')[0];
          if (orderDateStr === selectedDate) {
            dailyRevenue += cost * quantity;
            dishCount[item.name] = (dishCount[item.name] || 0) + quantity;
          }
        }

        // 🟢 Считаем за весь месяц
        if (isSameMonth) {
          monthlyRevenue += cost * quantity;
        }
      });
    });

    const topDishes = Object.entries(dishCount)
      .sort((a, b) => b[1] - a[1])
      .slice(0, 5);

    return {
      dailyRevenue,
      monthlyRevenue,
      topDishes
    };
  }, [orders, selectedDate]);

  return (
    <div className="text-white p-6 max-w-6xl mx-auto space-y-12">
      <h1 className="text-3xl font-bold mb-4">📊 Статистика поставщика</h1>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="bg-gray-800 rounded p-4 shadow space-y-4">
          <label className="block text-sm font-medium text-gray-300">Фильтр по дате:</label>
          <input
            type="date"
            className="bg-gray-900 border border-gray-700 text-white rounded p-2 text-sm w-full"
            value={selectedDate}
            onChange={e => setSelectedDate(e.target.value)}
          />
        </div>
      </div>

      {/* Финансовые показатели */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
        <div className="bg-gray-800 rounded p-6 shadow">
          <h2 className="text-xl font-semibold">📆 Выручка за выбранный день</h2>
          <p className="text-3xl mt-3 text-green-400">
            {generalStats.dailyRevenue.toLocaleString()} ₽
          </p>
        </div>
        <div className="bg-gray-800 rounded p-6 shadow">
          <h2 className="text-xl font-semibold">📅 Общая выручка за месяц</h2>
          <p className="text-3xl mt-3 text-blue-400">
            {generalStats.monthlyRevenue.toLocaleString()} ₽
          </p>
        </div>
      </div>

      {/* Топ блюд */}
      {selectedDate && (
        <div className="bg-gray-800 rounded p-6 shadow">
          <h2 className="text-xl font-semibold mb-4">🍱 Топ блюд по продажам (на выбранную дату)</h2>
          <ul className="list-disc list-inside text-sm text-gray-300 space-y-1">
            {generalStats.topDishes.map(([name, count]) => (
              <li key={name}>{name} × {count}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default SupplierStats;
